// extracted by mini-css-extract-plugin
export var circle = "_fb-1";
export var exitConfirmationModal = "_fb-5";
export var iframe = "_fb-0";
export var offline = "_fb-3";
export var online = "_fb-2";
export var workstationSelectError = "_fb-4";